import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-progress-bar-bullets',
  templateUrl: './progress-bar-bullets.component.html',
  styleUrls: ['./progress-bar-bullets.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressBarBulletsComponent {
  @Input()
  public currentIndex$;
  @Input()
  public stepOrder: number;
}
